import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqs = [
  { q: 'faq_q1', a: 'faq_a1' },
  { q: 'faq_q2', a: 'faq_a2' },
  { q: 'faq_q3', a: 'faq_a3' },
  { q: 'faq_q4', a: 'faq_a4' },
  { q: 'faq_q5', a: 'faq_a5' },
  { q: 'faq_q6', a: 'faq_a6' },
];

export default function FAQPrix() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section ref={ref} id="faq" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('faq_h2')}
      </h2>

      <div className="space-y-3">
        {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return (
            <div
              key={idx}
              className={`border border-soft-gray rounded-lg overflow-hidden transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${idx * 80 + 150}ms` }}
            >
              <button
                onClick={() => setOpenIdx(isOpen ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-white hover:bg-soft-gray/50 transition-colors"
              >
                <span className="font-manrope font-semibold text-slate-primary text-sm md:text-base pr-4">{t(faq.q)}</span>
                <i className={`ri-${isOpen ? 'subtract' : 'add'}-line text-copper shrink-0`} />
              </button>
              {isOpen && (
                <div className="px-5 pb-4 bg-white">
                  <p className="text-slate-primary/60 text-sm md:text-base leading-relaxed">{t(faq.a)}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}